<template>
  <div style="width: 100%" v-if="currentSchool">
    <v-container class="px-md-8 py-md-5">
      <v-row class="justify-center">
        <v-col cols="12" sm="7">
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-card outlined>
                <v-container>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="8" class="text-h6">Osnovni podaci</v-col>
                  </v-row>
                  <v-row v-for="(value, key, index) in schoolInfo" :key="index">
                    <v-col class="text-right font-weight-light"
                    >{{ key }}:</v-col
                    >
                    <v-col cols="8">{{ value }}</v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col
            cols="12"
            sm="3"
            v-if="
            $checkPermission('schools edit')
          "
        >
          <v-btn
              v-if="$checkPermission('schools edit')"
              block
              depressed
              height="44"
              class="primary text-none mb-4"
              @click="editItem"
          >
            <v-icon class="mr-2">
              mdi-pencil
            </v-icon>
            Uredi
          </v-btn>
          <v-btn
              v-if="$checkPermission('department enrollment edit document')"
              block
              depressed
              height="44"
              class="primary text-none mb-4"
              @click="openTemplateDialog"
          >
            Pregledaj diplome
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        v-model="templateDialog"
        width="500"
        @click:outside="closeTemplateDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Diplome</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeTemplateDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container class="pt-6">
          <v-row>
            <v-col>
              <ValidationProvider
                  :name="item.name"
                  :rules="item.rules"
                  mode="eager"
                  ref="provider"
                  v-bind:key="item.name"
                  v-for="item in items"
              >
                <div slot-scope="{ errors }">
                  <v-row no-gutters>
                    <!--Label for the form-->
                    <v-col
                        cols="12"
                        md="3"
                        style="height: 44px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-2"
                      >
                        <span
                            class="font-weight-bold text--primary"
                            :style="{
                            color:
                              errors.length > 0
                                ? 'rgb(236 29 36) !important'
                                : '',
                            opacity: 0.8,
                            marginRight: '8px',
                          }"
                        >{{ item.title }}:</span
                        >
                      </div>
                    </v-col>
                    <!-- Text field -->
                    <v-col cols="12" md="9">
                      <v-text-field
                          dense
                          :name="item.name"
                          outlined
                          :type="item.type"
                          :placeholder="
                          item.rules && item.rules.includes('required')
                            ? 'Obavezno...'
                            : ''
                        "
                          :prepend-icon="item.icon"
                          v-if="item.tag === 'input'"
                          v-model="form[item.name]"
                      >
                      </v-text-field>

                      <v-autocomplete
                          outlined
                          dense
                          :placeholder="item.rules ? 'Obavezno..' : ''"
                          :items="item.source"
                          :name="item.name"
                          :prepend-icon="item.icon"
                          :item-text="item.text"
                          return-object
                          v-if="item.tag === 'select'"
                          v-model="diploma"
                      >
                      </v-autocomplete>

                      <!-- Date picker -->
                      <v-menu
                          v-model="item.model"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-if="item.tag === 'date'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              outlined
                              dense
                              v-model="form[item.name]"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="form[item.name]">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </div>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                  depressed
                  class="text-none mb-3"
                  color="primary"
                  block
                  target="_blank"
                  :disabled="!diploma"
                  @click="loadDiploma(diploma)"
              >
                <v-icon class="mr-2" size="20"> mdi-file-find </v-icon>
                Pregled
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { extend, setInteractionMode, ValidationProvider } from "vee-validate";
import { digits, email, max, min, required } from "vee-validate/dist/rules";
import ApiV2 from "@/services/ApiV2";

export default {
  name: "Home",
  components: {
    ValidationProvider,
  },
  data() {
    return {
      templateDialog: false,
      schoolInfo: {},
      cantonTemplates: [],
      form: {},
      diploma: null,
      items: [
        {
          data: "diploma_template_id",
          name: "diploma_template_id",
          options: "",
          rules: "",
          source: [],
          text: "label",
          value: "id",
          tag: "select",
          type: "text",
          title: "Predložak",
        },
      ],
    };
  },
  computed: {
    currentSchool() {
      return this.$store.getters.getSchool;
    },
  },
  created() {
    this.optimizeData();
    setInteractionMode("eager");

    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", { ...required, message: "Ovo polje je obavezno." });

  },
  methods: {
    loadDiploma(diploma) {
      let baseUrl = process.env.VUE_APP_SKOLE_API_URL;
      baseUrl = baseUrl + "v2/";

      window.open(`${baseUrl}files/${diploma.resource_file?.uuid}`, "_blank");
    },


    openTemplateDialog() {
      Object.assign(this.form, this.currentSchool);
      this.getCantonTemplates();
      this.templateDialog = true;
    },
    closeTemplateDialog() {
      this.templateDialog = false;
      this.form = {};
      this.diploma = null;
    },

    async getCantonTemplates() {
     let {data} =  await ApiV2.get(
          `document_templates`,{params: {
            perPage: -1,
            filter:{
              model_id: this.currentSchool?.canton.id
            },
              filterRelation:{
                templateType:{
                  is_neutral: 1
                }
              },
             with:['resourceFile']
            }}
      )
        this.cantonTemplates = data.data;

      this.items.forEach((item) => {
        if (
            item.name === "semester_template_id" ||
            item.name === "diploma_template_id"
        ) {
          item.source = this.cantonTemplates;
        }
      });
    },

    // Novi način kad skontamo kako odvojit postojece od onih univerzalnih
    // async getCantonTemplates() {
    //   await ApiV2.get(
    //       `cantons/${this.currentSchool?.canton.id}`,{params:{with:['documentTemplates.templateType', 'documentTemplates.file']}}
    //   ).then((response) => {
    //     this.cantonTemplates = response.data.document_templates.filter(x=>x.file_id);
    //     this.items.forEach((item) => {
    //       if (
    //           item.name === "semester_template_id" ||
    //           item.name === "diploma_template_id"
    //       ) {
    //         item.source = this.cantonTemplates;
    //       }
    //     });
    //   });
    // },

    editItem() {
      this.$navigate(
          "/admin/skola/add" +
          (this.currentSchool.id > 0 ? "/" + this.currentSchool.id : "")
      );
    },

    optimizeData() {
      const {
        name,
        address,
        type,
        contact_phone,
        contact_email,
        headmaster,
        is_v_d_headmaster,
        contact_person,
        contact_it,
      } = this.currentSchool;
      this.schoolInfo = {
        "Naziv škole": name,
        Adresa: address,
        Vrsta: type,
        Telefon: contact_phone,
        "E-mail": contact_email,
        Ravnatelj: headmaster ? headmaster.full_name : "",
        "V.d. ravnatelja": is_v_d_headmaster === 0 ? "Ne" : "Da",
        "Kontakt osoba": contact_person,
        "IT kontakt": contact_it,
      };
    },
  },
  watch: {
    currentSchool: function(newVal) {
      this.optimizeData();
      if (!newVal) {
        this.$router.push("/admin");
      }
    },

  },
};

</script>

<style scoped>

</style>